import { yupResolver } from '@hookform/resolvers/yup';
import { useBunja } from 'bunja/react';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';

import { RhfProvider } from '@flipster/features/src/shared/react-hook-form';
import { Modal } from '@flipster/ui/Modal';

import OpenPosition from '@web/features/modals/TimeTriggerTpslModal/OpenPosition';
import PendingPosition from '@web/features/modals/TimeTriggerTpslModal/PendingPosition';
import { useTimeTriggerTpslModal } from '@web/features/modals/TimeTriggerTpslModal/useTimeTriggerTpslModal';

import { TpslSchema, validationBunja } from './bunja/validation';
import styles from './tpslModal.module.scss';

// 기존 TPSL Modal은 features/src/tpslModal로 전환되었고,
// 이 TPSL Modal은 TimeTrigger만 남아있다. 따라서, 실질적으로 TimeTriggerOrder 전용 TPSL Modal이다.

const TimeTriggerTpslModal = () => {
  const transPosition = useTranslations('Position.r250401');
  const { tpslValidator } = useBunja(validationBunja);
  const methods = useForm<TpslSchema>({
    mode: 'onChange',
    resolver: yupResolver(tpslValidator),
  });

  const { isShow, tpSlInfo, onCloseTimeTriggerTpslModal } = useTimeTriggerTpslModal();

  return (
    <Modal
      size='small'
      isShow={isShow}
      header={transPosition(tpSlInfo?.tpSlType === 'tp' ? 'Take_profit_title' : 'Stop_loss_title')}
      onClose={onCloseTimeTriggerTpslModal}
      className={styles.modal}
      withFooter
    >
      <RhfProvider methods={methods}>
        {tpSlInfo?.positionType === 'open' && <OpenPosition />}
        {tpSlInfo?.positionType === 'pending' && <PendingPosition />}
      </RhfProvider>
    </Modal>
  );
};

export default TimeTriggerTpslModal;
